import { TIER_FEATURES } from './tierFeatures';
import { TIERS_LOW_TO_HIGH } from './tiersLowToHigh';
import type { SubscriptionFeature, SubscriptionTier } from './types';

/**
 * The lowest subscription tier whose `TIER_FEATURES` grant includes the feature.
 * Every `SubscriptionFeature` is granted by `elite`, so a tier is always found.
 */
export const getRequiredTier = (feature: SubscriptionFeature): SubscriptionTier => {
  const tier = TIERS_LOW_TO_HIGH.find((candidate) => TIER_FEATURES[candidate].includes(feature));
  return tier ?? 'elite';
};
